export const SET_DATA_MODELS = 'dataModel//SET_DATA_MODELS'

// Interfaces for State and Actions
export interface DataModels {
  customerIdIssuedByList?: any
  customerTypeOfDocumentList?: any
  cityList?: any
  countryList?: any
  maritalStatusList?: any[]
  customerSalutationList?: any
  customerIsPoliticallyExposedPersonList?: { value: string; label: string }[]
  label?: any
  value?: any
  incomeRangeList?: any
  customerOccupationGroupList?: any
  countryCodes?: string[]
  provinceList?: any
  data?: Record<string, any>
}

interface Action<T = any> {
  type: string
  payload?: T
}

// Action Creator
export function setDataModels(
  data: Record<string, any>
): Action<Record<string, any>> {
  return {
    type: SET_DATA_MODELS,
    payload: data,
  }
}

// Selector Function
export function getDataModels(store: {
  dataModel: DataModels
}): Record<string, any> | undefined {
  return store.dataModel.data
}

// Initial State
const initialState: DataModels = {
  data: {},
  countryCodes: [],
  provinceList: [],
  maritalStatusList: [],
}

// Reducer
export default function(state = initialState, action: Action): DataModels {
  switch (action.type) {
    case SET_DATA_MODELS:
      return {
        ...state,
        data: action.payload || {}, // Ensure payload is not undefined
      }

    default:
      return state
  }
}
